import type { WalletResponse } from '@pixelworld/shared';
import { api } from '../../lib/api';

export const fetchWallet = () => api<WalletResponse>('GET', '/wallet');
